import { useEffect, useRef, useState } from "react"
import { Icon } from "../../../../components/icon"

export const FormInput = ({ colStyle, startIcon, endIcon, label, labelStyle, messageStyle, updateField, validators = [], mask, onChange,onBlur, onFocus, sufix = null, ...props }) => {
    const [firstClick, setFirstClick] = useState(true);

    const [isValid, setIsValid] = useState(true);
    const [isFocused, setIsFocused] = useState(false);

    const [invalidMessage, setInvalidMessage] = useState('');

    const inputField = useRef(null);

    const Change = (e) => {

        let val = e.target.value
        if (mask !== undefined && mask != null) {
            val = mask(val)
        }
        setIsValid(true);
        setInvalidMessage("");


        if (validators != null && validators.length > 0) {
            for (const validator of validators) {
                let data = { valid: true, message: "" }

                if (validator.argument != null && validator.argument !== undefined)
                    data = validator.func(val, validator.argument);
                else {
                    data = validator.func(val);
                }

                if (data.valid === false) {
                    setIsValid(false);
                    setInvalidMessage(data.message)
                    break;
                }
            }
        }

        e.target.value = val;

        if (onChange !== undefined) {
            onChange(e);
        }
    }
    const Focus = (e, focus = true) => {
        setFirstClick(false);
        setIsFocused(focus);
        if(focus && onFocus !== undefined)
            onFocus(e)
        else if(!focus && onBlur !== undefined)
            onBlur(e)

    }

    useEffect(() => {
        if (inputField?.current !== undefined) {
            if (validators != null && validators.length > 0) {
                for (const validator of validators) {
                    const data = validator.func(inputField.current.value, validator.argument);
                    if (data.valid === false) {
                        setIsValid(false);
                        setInvalidMessage(data.message)
                        break;
                    }
                }
            }
        }
    }, [validators])

    useEffect(() => {
        if (updateField != null && updateField !== undefined) updateField(props.id, isValid)
    }, [isValid])

    return (
        <span className='form-col' style={colStyle} data-valid={(!isValid) && (!isFocused) && (!firstClick) ? "false" : "true"}>
            <label className='form-label' htmlFor={props.id} style={labelStyle}>{label}</label>
            <div className={'form-container ' + props.className} style={props.style} >
                {props.type !== "textarea" ? 
                <>
                
                    {startIcon && <span style={{ paddingRight: "5px" }}><Icon icon={startIcon} /></span>}
                    
                    <input ref={inputField} data-valid={(!isValid) && (!isFocused) && (!firstClick) ? "false" : "true"} {...props} name={props.id}
                        onChange={Change}
                        // onInput={(e) => {Focus(e, false)}}
                        onBlur={(e) => { Focus(e, false) }}
                        onFocus={Focus}
                    />
                    
                    {sufix != null && <span style={{ paddingLeft: "5px",fontWeight:"bold" }} className="form-icon">{sufix}</span>}
                    {endIcon && <span style={{ paddingLeft: "5px" }} className="form-icon"><Icon icon={endIcon} /></span>}
                
                </>
                    :
                    <textarea ref={inputField} data-valid={(!isValid) && (!isFocused) && (!firstClick) ? "false" : "true"} {...props} name={props.id} rows="3" 
                    onChange={Change}
                    // onInput={(e) => {Focus(e, false)}}
                    onBlur={(e) => { Focus(e, false) }}
                    onFocus={Focus}
                    />
                }
            </div>
            {(!firstClick && !isValid && !isFocused) && <span className="form-message" style={messageStyle}> {invalidMessage} </span>}
        </span>
    )
}
